import React from "react";
import BlueHero from "../../assets/images/fullNameHero.svg";
import CallIcon from "../../assets/icons/Call.svg";
import EmailIcon from "../../assets/icons/Email.svg";
import BibleIcon from "../../assets/icons/bible.svg";
import GroupIcon from "../../assets/icons/fellowship.svg";
import ImpactIcon from "../../assets/icons/victory.svg";
import ServiceIcon from "../../assets/icons/service.svg";

const SupportUsPage = () => {
    return (
        <div className="bg-white font-sans">
            {/* Hero Section */}
            <div
                className="relative h-[700px] bg-cover bg-center flex flex-col items-center justify-center text-center text-white px-4"
                style={{ backgroundImage: `url(${BlueHero})` }}
            >
                <div className="absolute inset-0 bg-darkBlue/80"></div>
                <div className="relative z-10 flex flex-col items-center max-w-4xl mx-auto">
                    <span className="border border-mustardYellow text-mustardYellow px-6 py-2 rounded-full mb-8 uppercase text-xl font-semibold tracking-wide">
                        Support Us
                    </span>
                    <h1 className="text-3xl md:text-6xl font-bold mb-8 leading-tight">
                        CBR Vision is supported by
                        <br />
                        Bible readers and friends of the Ministry
                    </h1>
                    <p className="max-w-3xl text-lg md:text-xl text-gray-200 leading-relaxed">
                        Are you a <span className="text-mustardYellow">CBR graduate</span>? Your prayers and financial support will help train more believers in the
                        discipline of Bible reading.
                    </p>
                    <p className="max-w-3xl text-lg md:text-xl mt-4 text-gray-200 leading-relaxed">
                        Are you a <span className="text-mustardYellow">Bible enthusiast</span> who wishes to see many people empowered with
                        a daily, systematic Bible-reading habit? Email or call us and we will connect with you.
                    </p>
                </div>
            </div>

            {/* Contact Cards */}
            <div className="container mx-auto px-4 -mt-24 relative z-20 mb-20">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {/* Call Card */}
                    <div className="bg-white rounded-3xl shadow-xl shadow-blue-50 border-t-8 border-t-blue-50 p-10 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300">
                        <div className="w-20 h-20 bg-blue-50 rounded-3xl flex items-center justify-center mb-6 shadow-inner">
                            <img src={CallIcon} alt="Call us" className="w-8 h-8" />
                        </div>
                        <h3 className="font-bold text-xl mb-2 text-gray-800">Call us on</h3>
                        <p className="text-gray-600 text-lg">+254 700918161</p>
                    </div>

                    {/* Email Card */}
                    <div className="bg-white rounded-3xl shadow-xl shadow-yellow-50 border-t-8 border-t-yellow-50 p-10 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300">
                        <div className="w-20 h-20 bg-yellow-50 rounded-3xl flex items-center justify-center mb-6 shadow-inner">
                            <img src={EmailIcon} alt="Email us" className="w-8 h-8" />
                        </div>
                        <h3 className="font-bold text-xl mb-2 text-gray-800">Email us at</h3>
                        <p className="text-gray-600 text-lg">info@wordfeast.org</p>
                    </div>

                    {/* One Time Gift Card */}
                    <div className="bg-white rounded-3xl shadow-xl shadow-green-50 border-t-8 border-t-green-50 p-10 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300">
                        <div className="w-20 h-20 bg-green-50 rounded-3xl flex items-center justify-center mb-6 shadow-inner">
                            <img src={GroupIcon} alt="One time gift" className="w-8 h-8" />
                        </div>
                        <h3 className="font-bold text-xl mb-2 text-gray-800">Financial Gifts</h3>
                        <p className="text-gray-600 text-lg">
                            Mpesa Paybill: 4040471
                            <br />
                            AC: Gift
                        </p>
                    </div>
                </div>
            </div>

            {/* Why Your Support Matters */}
            <div className="pb-20 container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold mb-4 text-gray-800">
                        Why Your Support Matters
                    </h2>
                    <p className="text-gray-500">
                        Every contribution helps equip believers with the training
                        they need to become disciplined bible readers
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl mx-auto">
                    {/* Feature 1 */}
                    <div className="flex flex-col items-center text-center">
                        <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 text-blue-500">
                            <img src={BibleIcon} alt="Training Resources" className="w-8 h-8" />
                        </div>
                        <h3 className="font-bold text-lg mb-3 text-gray-800">
                            Training Resources
                        </h3>
                        <p className="text-gray-700 text-md leading-relaxed max-w-xs">
                            Books, materials, and guides for consistent Bible reading
                        </p>
                    </div>

                    {/* Feature 2 */}
                    <div className="flex flex-col items-center text-center">
                        <div className="w-16 h-16 bg-yellow-50 rounded-2xl flex items-center justify-center mb-6 text-yellow-500">
                            <img src={GroupIcon} alt="Expanding Reach" className="w-8 h-8" />
                        </div>
                        <h3 className="font-bold text-lg mb-3 text-gray-800">
                            Expanding Reach
                        </h3>
                        <p className="text-gray-700 text-md leading-relaxed max-w-xs">
                            Training more believers across multiple regions
                        </p>
                    </div>

                    {/* Feature 3 */}
                    <div className="flex flex-col items-center text-center">
                        <div className="w-16 h-16 bg-purple-50 rounded-2xl flex items-center justify-center mb-6 text-purple-500">
                            <img src={ImpactIcon} alt="Lasting Impact" className="w-8 h-8" />
                        </div>
                        <h3 className="font-bold text-lg mb-3 text-gray-800">
                            Lasting Impact
                        </h3>
                        <p className="text-gray-700 text-md leading-relaxed max-w-xs">
                            Establishing a culture of daily and systematic Bible reading in the churches
                        </p>
                    </div>
                </div>
            </div>

            {/* Footer CTA */}
            <div className="container mx-auto px-4 pb-24">
                <div className="bg-foundationBlue text-white rounded-lg py-4 px-8 flex items-center justify-center gap-3 max-w-2xl mx-auto shadow-lg">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-white"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                            clipRule="evenodd"
                        />
                    </svg>
                    <span className="font-medium text-sm md:text-base">
                        Every gift makes a difference in training believers to read God's word
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SupportUsPage;
